export const durationMapping = [
  {
    minDays: 0,
    maxDays: 1,
    chartOptions: ['line'],
    defaultChart: 'line',
    xAxisOptions: {
      line: ['hour'],
      column: [],
      columnGrouped: [],
    },
    defaultXAxis: {
      line: 'hour',
      column: null,
      columnGrouped: null,
    },
    sliceOptions: {
      line: ['total'],
      column: [],
      columnGrouped: [],
    },
    defaultSlice: {
      line: 'total',
      column: null,
      columnGrouped: null,
    },
  },
  {
    minDays: 1,
    maxDays: 7,
    chartOptions: ['column', 'columnGrouped', 'line'],
    defaultChart: 'line',
    xAxisOptions: {
      line: ['hour'],
      column: ['day'],
      columnGrouped: ['day'],
    },
    defaultXAxis: {
      line: 'hour',
      column: 'day',
      columnGrouped: 'day',
    },
    sliceOptions: {
      line: ['day', 'night', 'total', 'holiday'],
      column: ['day', 'night', 'total', 'holiday'],
      columnGrouped: ['day', 'night', 'total', 'holiday'],
    },
    defaultSlice: {
      line: 'total',
      column: 'day, night, total',
      columnGrouped: 'day, night, total',
    },
  },
  {
    minDays: 7,
    maxDays: 14,
    chartOptions: ['column', 'columnGrouped', 'line'],
    defaultChart: 'line',
    xAxisOptions: {
      line: ['hour'],
      column: ['day', 'week'],
      columnGrouped: ['day', 'week'],
    },
    defaultXAxis: {
      line: 'hour',
      column: 'day',
      columnGrouped: 'day',
    },
    sliceOptions: {
      line: ['day', 'night', 'total', 'holiday'],
      column: ['day', 'night', 'total', 'holiday', 'weekday', 'weekend'],
      columnGrouped: ['day', 'night', 'total', 'holiday', 'weekday', 'weekend'],
    },
    defaultSlice: {
      line: 'total',
      column: 'day, night, total',
      columnGrouped: 'day, night, total',
    },
  },
  {
    minDays: 14,
    maxDays: 28,
    chartOptions: ['column', 'columnGrouped', 'line'],
    defaultChart: 'column',
    xAxisOptions: {
      line: ['hour'],
      column: ['day', 'week'],
      columnGrouped: ['day', 'week'],
    },
    defaultXAxis: {
      line: 'hour',
      column: 'day',
      columnGrouped: 'day',
    },
    sliceOptions: {
      line: ['day', 'night', 'total', 'holiday'],
      column: ['day', 'night', 'total', 'holiday', 'weekday', 'weekend'],
      columnGrouped: ['day', 'night', 'total', 'holiday', 'weekday', 'weekend'],
    },
    defaultSlice: {
      line: ['total', 'holiday'],
      column: ['day', 'night', 'total'],
      columnGrouped: ['day', 'night', 'total'],
    },
  },
  {
    minDays: 28,
    maxDays: 90,
    chartOptions: ['column', 'columnGrouped', 'line'],
    defaultChart: 'column',
    xAxisOptions: {
      line: ['hour'],
      column: ['day', 'week', 'month'],
      columnGrouped: ['day', 'week', 'month'],
    },
    defaultXAxis: {
      line: 'hour',
      column: 'day',
      columnGrouped: 'day',
    },
    sliceOptions: {
      line: ['day', 'night', 'total', 'holidays'],
      column: ['day', 'night', 'total', 'holidays', 'weekday', 'weekend'],
      columnGrouped: [
        'day',
        'night',
        'total',
        'holidays',
        'weekday',
        'weekend',
      ],
    },
    defaultSlice: {
      line: ['total', 'holidays'],
      column: ['total'],
      columnGrouped: ['total'],
    },
  },
  {
    minDays: 90,
    maxDays: 365,
    chartOptions: ['column', 'columnGrouped'],
    defaultChart: 'column',
    xAxisOptions: {
      line: [],
      column: ['day', 'week', 'month', 'year'],
      columnGrouped: ['week', 'month'],
    },
    defaultXAxis: {
      line: null,
      column: 'week',
      columnGrouped: 'week',
    },
    sliceOptions: {
      line: [],
      column: ['day', 'night', 'total', 'holidays', 'weekday', 'weekend'],
      columnGrouped: [
        'day',
        'night',
        'total',
        'holidays',
        'weekday',
        'weekend',
      ],
    },
    defaultSlice: {
      line: null,
      column: 'total',
      columnGrouped: 'total',
    },
  },
  {
    minDays: 365,
    maxDays: 730,
    chartOptions: ['column', 'columnGrouped'],
    defaultChart: 'column',
    xAxisOptions: {
      line: [],
      column: ['week', 'month', 'year'],
      columnGrouped: ['week', 'month', 'year'],
    },
    defaultXAxis: {
      line: null,
      column: 'month',
      columnGrouped: 'month',
    },
    sliceOptions: {
      line: [],
      column: ['day', 'night', 'total', 'holidays', 'weekday', 'weekend'],
      columnGrouped: [
        'day',
        'night',
        'total',
        'holidays',
        'weekday',
        'weekend',
      ],
    },
    defaultSlice: {
      line: null,
      column: 'total',
      columnGrouped: 'total',
    },
  },
  {
    minDays: 730,
    maxDays: Infinity,
    chartOptions: ['column', 'columnGrouped', 'line'],
    defaultChart: 'column',
    xAxisOptions: {
      line: [],
      column: ['month'],
      columnGrouped: ['month', 'year'],
    },
    defaultXAxis: {
      line: null,
      column: 'year',
      columnGrouped: 'year',
    },
    sliceOptions: {
      line: [],
      column: ['day', 'night', 'total', 'holidays', 'weekday', 'weekend'],
      columnGrouped: [
        'day',
        'night',
        'total',
        'holidays',
        'weekday',
        'weekend',
      ],
    },
    defaultSlice: {
      line: null,
      column: 'total',
      columnGrouped: 'total',
    },
  },
];
